import type {
  WebsiteAdFieldsFragment,
  VideoAdFieldsFragment,
  LeadAdFieldsFragment,
} from './auction-ads.gql-types';

export enum SiteSections {
  Birthdays = 'birthdays',
  DiscoUpdates = 'disco-updates',
  JobsDetails = 'jobs-details',
  JobsInline = 'jobs-inline',
  JobsJobList = 'jobs-job-list',
  JobsRecommendation = 'jobs-recommendation',
  JobsRecommendationMyJobs = 'jobs-recommendation-my-jobs',
  JobsSearch = 'jobs-search',
  Logout = 'logout',
  NetworkSearchAndSwipe = 'network-search-and-swipe',
  JobsDreamMachine = 'jobs-dream-machine',
  NotificationCenter = 'notification-center',
  Profile = 'profile',
  Search = 'search',
  SupiNetworkHome = 'supi-network-home',
}

export type AdFields =
  | WebsiteAdFieldsFragment
  | VideoAdFieldsFragment
  | LeadAdFieldsFragment;

export type AdsContext = {
  isCompleted: boolean;
  ads: AdFields[];
};
